// eslint-disable-next-line import/no-anonymous-default-export
export default {
  translation: {

    // General
    yes: "Yes",
    no: "No",
    cancel: "Cancel",
    showingRows: "Showing {{shown}} / {{total}}",
    close: "Close",
    caution: "Caution",
    accept: "Accept",
    save: "Save",
    actionsForSelection: "Actions for selection",

    processStatus: {
      INITIALIZED: "Initialized",
      UPLOADED: "Data Uploaded",
      STARTED: "Processing",
      PROCESSED: "Processing",
      FAILED: "Can not be processed",
      DISABLED: "Disabled",
      FINISHED: "Finished",
      PAUSED: "Paused temporarily",
      TRIGGERED: "Processing",
      DELETED: "Deleted",
      DELETING: "Deleting",
      PROBLEM: "Under Review",
      statusMapping: "For more information about process status, please refer to the documentation.", // wiki?
      description: {
        INITIALIZED: "Data is being prepared for processing",
        UPLOADED: "Data is uploaded and processing will start", // shall we show the same status as for STARTED?
        STARTED: "Data processing has started. It can take hours or even days depending on the data quantity and system load. If load is little and it takes longer than expected, please contact the support.", // longer than expected?
        PROCESSED: "The data was processed and metadata is being prepared.",
        FAILED: "The processing cannot be completed, an error occurred that we cannot resolve. This may be due to the uploaded data.",
        DISABLED: "The processing was disabled by an administrator. Process data is not available to be viewed.", // What user can do?
        FINISHED: "The processing has successfully finished. The data is visible in the viewers. Under Processes User Access the data viewing can be enabled for standard users.", // would be good to say user type, or guide where to check if he has viewing permissions
        PAUSED: "/Type: Video V2B only/ The processing is paused. It will be manually resumed.", // no user input, right?
        TRIGGERED: "The processing process has been triggered.", // shall we show the same status as for STARTED?
        DELETED: "The process and the associated data have been deleted.",
        DELETING: "The process and the associated data are being deleted",
        PROBLEM: "While processing the data, a problem has occurred and we are trying to resolve it. It might take some time, depending on the severity of issued. If resolved, the status will update to `Processing` and if not, to `Failed`.",
      },
    },
    systemHealth: {
      title: "Uploader System Load",
      subtitle: "Uploader System Load affects the speed of processing",
      LOW: "Low Load",
      MEDIUM: "Medium Load",
      HIGH: "High Load",
      VERY_HIGH: "Very High Load",
      description: {
        LOW: "Very few processes are currently being processed and it should not take long to process data.",
        MEDIUM: "Many processes are currently being processed and it might take some time for your data to get processed.",
        HIGH: "A lot of processes are currently being processed and it might take a while for your data to get processed.",
        VERY_HIGH: "A lot of processes are currently being processed and it might take a long time for your data to get processed.",
      },
      loading: "Loading uploader health...",
      error: "Could not load uploader health status",
      lastUpdated: "Last updated",
    },

    // User Access
    ua: {
      loading: "Loading...",
      project_not_loaded: "Unable to load project",
      access_denied: "Access denied",
      user_access: "User Access",
      user_name: "User name",
      email: "E-mail",
      roles: "Roles",
      email_address: "E-mail address",
      add_user: "Add user",
      import_user: "Import users from file",
      select_none: "Select\nnone",
      select_all: "Select\nall",
      remove_all: "Remove\nall",
      remove_selected: "Remove\nslected",
      export_all: "Export\nall",
      export_selected: "Export\nselected",
      copy_user_id: "Copy user ID",
      remove_user: "Remove user",
      copy_id: "Copy user ID",
      id_copied: "User ID copied",
      process_access: "Process Access",
      process_filter: "Process Filter",
      remove_process_filter: "Remove process filter",
      sections_and_processes: "Sections and finished processes",
      external: "External",
      internal: "Internal",
      collapse_expand_processes: "{{collapse}} processes of this section",
      collapse: "Collapse",
      expand: "Expand",
      alerts: {
        wrong_filetype: "The selected file '{{file}}' can't be read. Please select a .txt file'",
        user_not_added: "The following users could not be added",
        user_in_project: "User is already part of this project",
        user_added: "The following users have been successfully added",
        user_not_removed: "The following users could not be removed",
        remove_all_users: "Do you really want to remove all selected users ({{count}})?",
        remove_selected_users: "Do you really want to remove all selected users?",
        external_not_switched: "Could not change external worker access",
        internal_not_switched: "Could not change internal worker access",
        process_not_switched: "Could not change process access",
      },
    },

    // Viewer
    v: {
      loading: "Loading...",
      too_many_containers: "The maximal count of viewers is 3. " +
        "Please close one before continuing.",
      multiple_3d: "Multiple 3D-Containers",
      multiple_3d_text: "You're about to open more than one 3D-Container. " +
        "This may result in pointclouds loading slower than normal. " +
        "It's therefore recommended to limit the maximum pointcloud size. " +
        "Do you want to limit pointclouds to a maximum size of 250,000 points?" +
        "You can also change the maximum pointcloud size at any time in the settings in the 'POINTCLOUDS' menu.",
      add_panorama: "You have several 3D containers open. " +
        "In which should the panorama image be displayed?",
      multiple_panoramas: "Multiple panorama images found",
      multiple_panoramas_text: "Panorama images from various processes can be found at this location. " +
        "Which process's panorama image would you like to display?",
      other_process: "Panorama image from a different process",
      other_process_text: "The selected panorama image belongs to a different process than the currently displayed image. " +
        "Would you like to continue?",
      none: "None / Cancel",
      close: "Close",
      process_overlay_next_page: "{{count}} older processes...",
      process_overlay_prev_page: "{{count}} newer processes...",
      projectWithoutProcess: "This project contains no processes or is not available.",
      noImages: "There are no images or they were processed before 2023.",
      displayProfile: "Display profile",
      errorProfileAdding: "The profile could not be added to any of the current 3D viewers because at least one point is not in an active point cloud.",
      errorProfileAddingNew: "The profile could not be added to a new 3D viewer because at least one point is not in an active point cloud.",
      noActiveThreeDViewer: "For a profile to be displayed, it must be active in a 3D viewer. There are currently too many viewers open to add a new 3D viewer.",
      invalidContainer: "Invalid container to remove",
      automaticLoadingProcesses: "The automatic loading of processes is based on the left-hand map",
      automaticLoading: "A card is required for automatic loading.",
      measurementAlreadyActiveHeader: "Measurement active",
      measurementAlreadyActive: "A measurement is already active. Should this be ended and a new one started?",
      editingAlreadyActiveHeader: "Editing active",
      editingAlreadyActive: "A measurement is already being edited. Would you like to exit edit mode and start a new measurement?",
      addProfileToCurrent: "For a profile to be displayed, it must be active in a 3D viewer. Should this profile be added to one of the current 3D viewers?",
      addProfileToNew: "For a profile to be displayed, it must be active in a 3D viewer. Do you want to add a new 3D viewer? Note: this may take a few seconds.",
      alert: "This should not happen",
      max_active_geo_layers: "A maximum of {{count}} GEO/OBJECT layers can be active at the same time.",
      gnd_profile_requires_layer: "A profile needs a GND layer visible in the 3D viewer.",
      gnd_profile_no_visible_line: "No selectable GND line is visible in the current 3D view.",
      gnd_profile_failed: "The profile could not be created.",
      axis_measurement_requires_km_layer: "This measurement needs a kilometre layer (GND) visible in the 3D viewer.",
      axis_measurement_requires_track_layer: "This measurement needs a track axis layer (GND) visible in the 3D viewer.",
      axis_measurement_no_visible_axis: "No selectable axis is visible in the current 3D view.",
      axis_measurement_no_km_data: "The selected axis has no kilometre data.",
      axis_measurement_km_data_problem: "Problem with track network data.",
      axis_measurement_failed: "The axis measurement could not be completed.",
      windows: {
        catalog: "Catalog",
        measurements: "Measurements",
        layer_menu: "Layer menu",
        gis_object: "GIS object",
      },
      axis_measurement_names: {
        KILOMETRIERUNG: "Kilometry",
        KILOMETRIERUNG_DISTANCE: "Km axis",
        GLEISACHSE_DISTANCE: "Track axis",
        GLEISACHSE_GAP: "Axis distance",
      },
      measurement_details: {
        results: "Results",
        resample_elevation: "Take elevations from the point cloud",
        total_length: "Total length",
        projected_length: "Projected length",
        vertical_extent: "Vertical extent",
        line_details: "Details ({{segments}} segments, {{vertices}} vertices)",
        segments: "Segments ({{count}})",
        segment: "Seg. {{n}}",
        slope: "Slope",
        vertices: "Vertices ({{count}})",
        add_point: "Add point",
        area_2d: "Area (2D)",
        perimeter: "Perimeter",
        polygon_details: "Details ({{edges}} edges)",
        edges: "Edges ({{count}})",
        edge: "Edge {{n}}",
        fill: "Fill",
        cut: "Cut",
        total_volume: "Total volume",
        height_difference: "Height difference (ΔZ)",
        horizontal_distance: "Horizontal distance",
        distance_3d: "3D distance",
        base_point: "P1 (base)",
        compare_point: "P2 (compare)",
        volume_options: "Calculation options (volume)",
        flatten: "Flatten to a plane",
        plane_height: "Plane height",
        undo_flatten: "Undo (restore the original heights)",
        max_height: "maximum height difference",
        max_height_hint: "Maximum distance of a point from the reference plane to be counted",
        name: "Name",
        description: "Description",
        type_point: "Point",
        type_line: "Line",
        type_polygon: "Polygon",
        type_volume: "Volume",
        type_height_difference: "Height difference",
        labels: "Labels",
        mirror: "Mirror to the other view",
        finish_edit: "Finish editing",
        edit: "Edit",
        recalc_volume: "Recalculate volume",
        open_profile: "Open profile",
        zoom_to: "Zoom to",
      },
      axis_details: {
        km: "Kilometre position",
        km_data: "Track network data",
        side: "Side",
        distance_to_axis: "Distance to axis",
        series: "Series",
        role: "Kind",
        calibration: "Calibration",
        calibration_offset: "Calibrated offset",
        distance_along_axis: "Distance along axis",
        distance_to_track_centre: "Distance to track centre",
        distance_to_gnd_axis: "Distance to GND axis",
      },
      clip_reference_requires_axis_layer: "Slicing along an axis needs a GIS axis layer (GND) visible in the 3D viewer.",
      clip_reference_no_visible_axis: "No selectable axis is visible in the current 3D view.",
      max_active_geo_layers_short: "Max. {{count}}",
      too_many_panoramas: "X2BIM does not currently support the simultaneous display of panoramic images in different containers.",
      panorama_currently_active: "A panorama image associated with this process is currently displayed in the 3D container. " +
        "Please leave panorama mode before removing this process from the container.",

      // Menubar
      mb: {
        ortho: "Orthos",
        plan: "Plans",
        dgm: "DEMs",
        pointcloud: "Point Clouds",
        panorama: "360°",
        uav_lite: "Photos",
        glb: "IFC",
        video: "Video",
        ki: "Geo/Objects",
        annotation: "Annotations",
        ortho_long: "Ortho Images",
        plan_long: "Plans",
        dgm_long: "Digital Elevation Models",
        pointcloud_long: "Point Clouds",
        panorama_long: "Panoramas",
        glb_long: "IFC Models",
        video_long: "Track Videos",
        ki_long: "AI Objects",
        annotation_long: "Annotations",
        ortho_help: "The last activated ortho-image is displayed at the top of the map. " +
          'When selecting "load and sync automatically" in settings, the data is added chronologically, with the most recent process at the top.',
        plan_help: "We tile plans analogous to ortho images and display them on the map. " +
          'When selecting "load and sync automatically" in settings, the data is added chronologically, with the most recent process at the top. ' +
          "In general, plans are always superimposed on simultaneously displayed orthoimages and DEMs.",
        dgm_help: "We tile digital terrain models analogous to orthoimages and display them in reduced resolution on the map. " +
          'When selecting "load and sync automatically" in settings, the data is added chronologically, with the most recent process at the top. ' +
          "In general, DEMs are always superimposed on simultaneously displayed orthoimages.",
        pointcloud_help: "For better orientation in the 3D point cloud viewer, at least one point cloud should always be displayed. " +
          'The "Earth" camera mode only works on the basis of an active point cloud',
        panorama_help: "Currently, the upload of panoramic images is possible for the projects Video2BIM and Multisensorplattform. " +
          "After selecting a panorama in the 2D or 3D viewer, it is displayed in the 3D viewer; exiting the view is possible via the button at the bottom of the viewer. " +
          "Measuring in the panoramic image is only possible based on a simultaneously displayed point cloud.",
        glb_help: "In general, IFCs are always superimposed on simultaneously displayed point clouds.",
        video_help: "A red dashed line appears in the 2D viewer, which shows the route on which the selected video was recorded. " +
          "As soon as you click on the line, the video starts in a new container.",
        ki_help: "When uploading to X2BIM, the detection of LST objects can be activated. " +
          "If an object class is activated here, the objects appear on the map if the associated date is active in ORTHOS at the same time.",
        annotation_help: "Annotations can be created from distance measurements, area measurements and markers. " +
          "To do this, they must first be created using the toolbar at the bottom.<hr />" +
          "Creating an annotation is then possible via the measurement menu. " +
          "At the moment this is <b>only possible if the measurement was created on an ortho-image</b>. " +
          "It will then be displayed as a temporary annotation here in the annotation menu.<hr />" +
          'It is permanently saved using the "Save" button which appears in the expanded annotation.',
        uav_lite_help: "UAV Lite is a new format developed by X2BIM for displaying photos on the map. ",
        search: "Search",
        share: "Share",
        clear: "Reset Viewer",
        defaultSettings: "Default Settings",
        help: "Introduction/Help",
        container: "Container Management",
        screenshot: "Screenshot",
        account: "Account",
        project_loading: "Loading project...",
        cancel_loading: "Cancel loading",
        expand_settings: "Expand Settings",
        compare: "Compare",
        close_compare: "Close Compare",
        no_openlayers: "No 2D map/container active",
        too_many_openlayers: "Comparison mode can only be enabled in one 2D map. Please select a 2D map.",
        too_many_containers: "There's more than one active container. It's recommended to close all other containers before entering comparison mode.",
        remove_containers: "Close other containers",
        keep_containers: "Keep other containers",
        cancel: "Cancel",
        no_process: "No active process",
        linkcopied: "Link copied",
        download_option: "Select download option",
        no_settings_found: "No settings found",
        enabled: "Enabled",
        default: "Default",
        last_modified: "Last Modified",
        add_new_setting: "Add New Setting",
        edit_setting: "Edit Setting",
        setting_name: "Setting Name",
        set_default: "Set as Default",
        set_enabled: "Enable Setting",
        save: "Save",
        cancel: "Cancel"
      },

      //2D Container
      openLayers: {
        basePoint: "base point",
        noVideos: "No videos for this process found.",
        volumesOnly: "Volumes can only be calculated on DEMs and ortho images.",
        pointNoLongerOnProcess: "The modified point is no longer on a DEM or ortho image",
        errorVolumeCalculation: "Error while calculating the volume",
        errorVolumeDifference: "Volume differences can be only measured on DEMs or ortho images. On both sides of the compare modus tow different DEMs or ortho images should be active.",
        noProcess: "No process detected.",
        left: "LEFT",
        right: "RIGHT",
        on_axis: "ON AXIS",
        fill: "Fill",
        cut: "Cut",
        height: "Height dif."
      },

      //Potree Cotainer
      potree: {
        cancelTransmission: "At least one point in the measurment cannot be transmitted as its location is not inside the point cloud. The transmission is cancled.",
        threeDMeasurementNotPossible: "Measurements in 3D are not available on your device",
        polygonsInThreeD: "Polygons from track data can only be displayed in the 3D viewer if all points of the polygon are located within a point cloud.",
        removeProfile: "For a profile to be displayed, it must be active in a 3D viewer. If you remove the profile from this 3D viewer, the currently open profile viewer will also be closed. Would you like to continue?"
      },

      // Dropdowns
      dd: {
        pin_dropdown: "Pin dropdown",
        show_info: "Information",
        show_settings: "Settings",
        show_filter: "Filter options",
        search: "Search resources",
        search_placeholder: "Date | Title | Description | Tags",
      },

      // Geo data (old base map) menu
      base: {
        basemap: "Base map",
        grayscale: "Grayscale",
        terrain: "Terrain",
        satellite: "Satellite",
        hectometer: "Hectometer Points",
        ivl: "IVL Sections",
        openrailwaymap_infra: "OpenRailMap (Infrastructure)",
        openrailwaymap_signal: "OpenRailMap (LST)",
        process_clusters: "Process-Cluster",
        ivl_plans_west: "IVL Plans",
        active: "active",
        inactive: "inactive",
        pzb_magnet: "PZB-Magneten",
        acz: "ACZ",
        etc: "ETCS",
        schaltschrank: "Schaltschrank",
        mast: "Signale",
        increasezoom: "Increase zoom!",
        decreasezoom: "Decrease zoom!",
        nobasemapwarn: "Geo data settings are only available with an opened map",
        still_active_header: "Disabling not possible",
        still_active_content: "The geodata is still active in at least one 3D container. " +
          "To disable them on the map, they must first be disabled in all 3D containers. " +
          "Do you want to remove geodata from all 3D containers?",
        not_active_header: "Enabling not possible",
        not_active_content: "The geodata is not active on the map. " +
          "To enable them in a 3D container, they must first be enabled on the map. " +
          "Do you want to add geodata to the map?",
        clearMapHeader: "Are you sure you want to reset the viewer?",
        clearMapPopupMessage: "This action will erase all unsaved progress and restart the viewer. Click Yes to continue.",
      },

      // Process menus (Ortho, Pläne, DGMs, Punktwolken)
      process: {
        toggle_single: "Single",
        toggle_time: "Timespan",
        toggle_download: "Download",
        filter: "Filter...",
        download: "Download active resources",
        deselect: "Clear selection",
        dgm: "DEM",
        dom: "DSM",
        geo_inspect: "GeoInspect",
        uploads_from: "Uploads from {{date}} on",
        feb_2023: "02/2023",
        images: "Images",
        remove: "Remove {{geo_inspect}}",
        activate_all: "Enable all",
        activate_all_extent: "Enable all in extent",
        deactivate_all: "Disable all",
        open_viewer: "Open {{viewer}}",
        viewer_2d: "2D map",
        viewer_3d: "3D viewer",
        time_plans: "Timespan selection is not available for plans.",
        visible_processes: "processes",
        timespan: "Timespan",
        days: "Days",
        scanner: "Scanner",
        processes: "Processes",
        percent: "{{value}}%",
        top: "TOP",
        left: "Comp. left",
        right: "Comp. right",
        collapse: "Collapse individual resources in this group",
        expand: "Expand individual resources in this group",
        details: "Log resource information",
        copyUrl: "Copy pointcloud URL to clipboard",
        color: "Colorize pointcloud",
        color_all: "Colorize all active pointclouds in this group",
        elevation: "Colorize pointcloud by height",
        elevation_all: "Colorize all active pointclouds in this group by height",
        settingAll: "Display Properties",
        resetAttributes: "Reset Coloring",
        inspect: "Inspect function for this ortho image",
        inspect_all: "Inspect function for all active ortho images in this group",
        external_viewer: "Ext. Viewer",
        tagAktiv: "show only activated tags",
        link_types: "Load {{- types}} together",
        ortho_pointcloud: "ortho/pointcloud",
        pointcloud_panorama: "pointcloud/panorama",
        pointcloud_classes: {
          0: "Never classified",
          1: "Unassigned",
          2: "Ground",
          3: "Low Vegetation",
          4: "Medium Vegetation",
          5: "High Vegetation",
          6: "Building",
          7: "Low Point",
          8: "Model KeyPoint",
          9: "Water",
          10: "Rail",
          11: "Road Surface",
          12: "Reserved",
          13: "Wire - Guard (Shield)",
          14: "Wire - Conductor (Phase)",
          15: "Transmission Tower",
          16: "Wire-Structure Connector (Insulator)",
          17: "Bridge Deck",
          18: "High Noise",
          19: "Reserved",
          20: "Reserved",
          21: "Reserved",
          22: "Reserved",
          23: "Reserved",
          24: "Reserved",
          25: "Reserved",
          26: "Reserved",
          27: "Reserved",
          28: "Reserved",
          29: "Reserved",
          30: "Reserved",
          31: "Reserved",
          32: "Reserved",
          33: "Reserved",
          34: "Reserved",
          35: "Reserved",
          36: "Reserved",
          37: "Reserved",
          38: "Reserved",
          39: "Reserved",
          40: "Reserved",
          41: "Reserved",
          42: "Reserved",
          43: "Reserved",
          44: "Reserved",
          45: "Reserved",
          46: "Reserved",
          47: "Reserved",
          48: "Reserved",
          49: "Reserved",
          50: "Reserved",
          51: "Reserved",
          52: "Reserved",
          53: "Reserved",
          54: "Reserved",
          55: "Reserved",
          56: "Reserved",
          57: "Reserved",
          58: "Reserved",
          59: "Reserved",
          60: "Reserved",
          61: "Reserved",
          62: "Reserved",
          63: "Reserved",
          64: "User Definable",
          65: "User Definable",
          66: "User Definable",
          67: "User Definable",
          68: "User Definable",
          69: "User Definable",
          70: "User Definable",
          71: "User Definable",
          72: "User Definable",
          73: "User Definable",
          74: "User Definable",
          75: "User Definable",
          76: "User Definable",
          77: "User Definable",
          78: "User Definable",
          79: "User Definable",
          80: "User Definable",
          81: "User Definable",
          82: "User Definable",
          83: "User Definable",
          84: "User Definable",
          85: "User Definable",
          86: "User Definable",
          87: "User Definable",
          88: "User Definable",
          89: "User Definable",
          90: "User Definable",
          91: "User Definable",
          92: "User Definable",
          93: "User Definable",
          94: "User Definable",
          95: "User Definable",
          96: "User Definable",
          97: "User Definable",
          98: "User Definable",
          99: "User Definable",
          100: "User Definable",
          101: "User Definable",
          102: "User Definable",
          103: "User Definable",
          104: "User Definable",
          105: "User Definable",
          106: "User Definable",
          107: "User Definable",
          108: "User Definable",
          109: "User Definable",
          110: "User Definable",
          111: "User Definable",
          112: "User Definable",
          113: "User Definable",
          114: "User Definable",
          115: "User Definable",
          116: "User Definable",
          117: "User Definable",
          118: "User Definable",
          119: "User Definable",
          120: "User Definable",
          121: "User Definable",
          122: "User Definable",
          123: "User Definable",
          124: "User Definable",
          125: "User Definable",
          126: "User Definable",
          127: "User Definable",
          128: "User Definable",
          129: "User Definable",
          130: "User Definable",
          131: "User Definable",
          132: "User Definable",
          133: "User Definable",
          134: "User Definable",
          135: "User Definable",
          136: "User Definable",
          137: "User Definable",
          138: "User Definable",
          139: "User Definable",
          140: "User Definable",
          141: "User Definable",
          142: "User Definable",
          143: "User Definable",
          144: "User Definable",
          145: "User Definable",
          146: "User Definable",
          147: "User Definable",
          148: "User Definable",
          149: "User Definable",
          150: "User Definable",
          151: "User Definable",
          152: "User Definable",
          153: "User Definable",
          154: "User Definable",
          155: "User Definable",
          156: "User Definable",
          157: "User Definable",
          158: "User Definable",
          159: "User Definable",
          160: "User Definable",
          161: "User Definable",
          162: "User Definable",
          163: "User Definable",
          164: "User Definable",
          165: "User Definable",
          166: "User Definable",
          167: "User Definable",
          168: "User Definable",
          169: "User Definable",
          170: "User Definable",
          171: "User Definable",
          172: "User Definable",
          173: "User Definable",
          174: "User Definable",
          175: "User Definable",
          176: "User Definable",
          177: "User Definable",
          178: "User Definable",
          179: "User Definable",
          180: "User Definable",
          181: "User Definable",
          182: "User Definable",
          183: "User Definable",
          184: "User Definable",
          185: "User Definable",
          186: "User Definable",
          187: "User Definable",
          188: "User Definable",
          189: "User Definable",
          190: "User Definable",
          191: "User Definable",
          192: "User Definable",
          193: "User Definable",
          194: "User Definable",
          195: "User Definable",
          196: "User Definable",
          197: "User Definable",
          198: "User Definable",
          199: "User Definable",
          200: "User Definable",
          201: "User Definable",
          202: "User Definable",
          203: "User Definable",
          204: "User Definable",
          205: "User Definable",
          206: "User Definable",
          207: "User Definable",
          208: "User Definable",
          209: "User Definable",
          210: "User Definable",
          211: "User Definable",
          212: "User Definable",
          213: "User Definable",
          214: "User Definable",
          215: "User Definable",
          216: "User Definable",
          217: "User Definable",
          218: "User Definable",
          219: "User Definable",
          220: "User Definable",
          221: "User Definable",
          222: "User Definable",
          223: "User Definable",
          224: "User Definable",
          225: "User Definable",
          226: "User Definable",
          227: "User Definable",
          228: "User Definable",
          229: "User Definable",
          230: "User Definable",
          231: "User Definable",
          232: "User Definable",
          233: "User Definable",
          234: "User Definable",
          235: "User Definable",
          236: "User Definable",
          237: "User Definable",
          238: "User Definable",
          239: "User Definable",
          240: "User Definable",
          241: "User Definable",
          242: "User Definable",
          243: "User Definable",
          244: "User Definable",
          245: "User Definable",
          246: "User Definable",
          247: "User Definable",
          248: "User Definable",
          249: "User Definable",
          250: "User Definable",
          251: "User Definable",
          252: "User Definable",
          253: "User Definable",
          254: "User Definable",
          255: "User Definable"
        },
        pointcloud_eyedom: "Eye-Dome-Lighting",
        pointcloud_elevation: "Elevation",
        pointcloud_elevationRepeat: "Elevation",
        pointcloud_elevationMin: "Base height",
        pointcloud_elevationInterval: "Interval",
        pointcloud_elevationRange: "Elevation Interval",
        pointcloud_color: "Colour",
        pointcloud_colorClass: "Colour by classification",
        pointcloud_intensity: "Instensity",
        pointcloud_intensityGradient: "Instensity Gradient",
        pointcloud_intensityRange: "Intensity Range",
        pointcloud_RGBAGamma: "Gamma",
        pointcloud_RGBABrightness: "Brightness",
        pointcloud_RGBAContrast: "Contrast",
        pointcloud_intesityGradiantGamma: "Gamma",
        pointcloud_intesityGradiantBrightness: "Brightness",
        pointcloud_intesityGradiantContrast: "Contrast",
        pointcloud_reset: "Reset",
        filterText: "by time, name or tag",
        timestart: "between",
        timeend: "and",
        includes: "includes",
        showmodel: "Show model",
        showwireframe: "Show wireframe",
        settings: "Settings",
        autoload: "Load resources automatically",
        process_clusters: "Show Prozess-Clusters",
        sortby_date: "date",
        sortby_title: "titel",
        sortby_description: "description",
        alloff: "All off",
        transparency: "Transparency",
        opacity: "Opacity",
        max_points: "Maximum {{count}} points",
        point_size: "Point Size",
        small: "Small",
        large: "Large",
        point_budget: "Point Budget",
        low: "Low",
        high: "High",
        filter_type: "Type",
        filter_extent: "Map extent",
        filter_extent_help: "If switched on, only resources inside the current map extent are shown",
        filter_date: "Date",
        filter_tag: "Tag",
        filter_type_drone: "Multicopter flight",
        filter_type_helicopter: "Helicopter flight",
        filter_type_video: "Video2BIM",
        filter_type_train: "MSP train inspection",
        filter_type_cad: "Plan",
        filter_type_null: "Miscellaneous",
        open_calendar: "Open calendar selection",
        reset_filters: "Reset filter settings",
        resources_filtered: "Filter: {{filtered}} of {{total}} resources shown",
        no_resources_filtered: "There are no matching resources for these filter settings",
        no_date: "No date",
        no_title: "No title",
        no_description: "No description",
        resource_count: "{{count}} resources",
        new_3d: "New 3D viewer",
        new_2d: "New 2D map",
      },

      // KI menu
      ki: {

        ai_objects: "AI Objects",
        overview: "Overview",
        track_data: "Track data",
        detections: "AI Objects",
        Strecken: "Track",
        Objekte: "Other GIS data",
        WMS: "WMS Services (Experimental)",
      },

      // Annotations menu
      annot: {
        not_available: "not available",
        archived: "ARCHIVED",
        viewer_2d: "2D Map",
        viewer_3d: "3D Viewer",
        save: "Save",
        archive: "Archive",
        download: "Download as JSON",
        title: "Title",
        flight: "Flight name",
        dimension: "Dimension",
        trade: "Trade",
        edit: "Edit",
        saved: "Saved",
        unsaved: "Unsaved",
        created: "Created",
        changed: "Last modified",
        description: "Description",
        unsaved_tooltip: "unsaved ({{value}})",
        unsaved_name: "unsaved {{meastype}} annotation",
        header: "Create annotation",
        process_found: 'Process of type "{{processtype}}" found',
        no_process: "No associated process was found.",
        with: "Refer to process",
        without: "Without process reference",
        create: "New annotation",
        extend: "Extend annotation",
        save_first: "Save annotation first",
        selected: "selected",
        create_button: "Create annotation",
        extend_button: "Extend annotation(s)",
        meastypes: {
          distance: "distance",
          area: "area",
          volume: "volume",
          volume_delta: "volume difference",
          marker: "coordinate marker",
          angle: "angle",
          height: "height difference",
          profile: "profile",
          kilometrierung: "kilometry",
          kilometrierung_distance: "kilometer axis",
          gleisachse_distance: "track axis",
          gleisachse_gap: "track axis",
          inspect: "geo inspect",
          inspect_active: "geo inspect",
          tile_inspect: "process inspect",
          gnd_inspect: "track object inspection",
        },
        processtypes: {
          ortho: "Ortho",
          plan: "Plan",
          dgm: "DEM",
        },
        trades: {
          "Brandschutz": "Fire protection",
          "KIB/Oberbau": "Structural engineering",
          "LST": "Signalling system",
          "MTA": "Mechanical equipment",
          "OLA": "Catenary system",
          "50 Hz": "50 Hz",
          "SiGeKo": "Safety/health coordinator",
          "SÜ": "Road overpass",
          "TK": "Telecommunications",
          "Sonstiges": "Other",
          "Übergreifend": "Overarching",
        },
        alerts: {
          invalid_trade: "Please select a valid trade.",
          error_sending: "An error occurred while sending the annotation data to the server.",
          error_connection: "There is a problem connecting to the annotation database.",
          unsaved_header: "Unsaved annotation",
          unsaved_text: "An unsaved annotation already exists. Do you want to overwrite it by the new annotation?",
          added_geom: "Geometry added.",
          only_2d: "Currently, only 2D annotations can be created. Please transfer the 3D measurement to the map if necessary.",
        },
      },

      // Search menu
      search: {
        search: "Search",
        kilometry: "Kilometry",
        show_km: "Show {{km}}",
        show: "Show",
        coordinates: "Coordinates",
        epsg: "EPSG",
        processes: "Processes",
        projects: "Projects",
        places: "Places",
        ivl: "IVL",
        search_history: "Search history",
        search_for: "Search for...",
        places_example: "'Hamburg' / 'Stuttgart' / 'Rummelsburg'",
        coordinates_example: "'13.4 52.5'",
        epsg_example: "DBREF/WebMerc/WGS84",
        kilometry_example: "'6362' / '6362 50,5'",
      },

      // Functionalities
      func: {
        lstdetected: "Detected Objects",
        connectedimages: "Connected images",
        showimages: "Show images",
        hideimages: "Hide omages",
        multiple_gnd: "Multiple track object layers found",
        km: "Kilometer Axis",
        tr: "Track Axis",
        hm: "Hectometer Point",
        obj: "Track Object",

        geometry: "Geometry",
        lineNumber: "Line number",
        directionIndicator: "Direction indicator",
        km: "Kilometry",
        fromKm: "Kilometry",
        toKm: "Kilometry",
        label: "Label",

        Point: "Point",
        MultiPoint: "Point",
        LineString: "Line",
        MultiLineString: "Line",
        Polygon: "Polygon",
        MultiPolygon: "Polygon",
      },

      // Share menu
      share: {
        copy_link: "Copy export link",
      },

      // Container management menu
      container: {
        switch_to: "Switch to {{view}}",
        column: "Column view",
        row: "Row view",
        auto_view_connect: "Synchronize new containers automatically",
        sync_rotation: "Synchronize rotation",
        sync_zoom: "Synchronize zoom",
        content_2d: "2D Map",
        content_OPENLAYERS: "2D Map",
        content_INSPECT: "Geo Inspect",
        content_PROFILE: "Profile",
        content_3d: "3D Viewer",
        content_POTREE: "3D Viewer",
        content_VIDEO: "Video",
        remove: "Remove",
        move: "Move container",
        add_2d: "+2D",
        add_3d: "+3D",
      },

      // Toolbar
      tb: {
        distance_title: "Measure distance",
        area_title: "Measure area",
        volume_title: "Measure volume",
        volume_delta_title: "Measure volume difference",
        marker_title: "Add coordinate marker",
        angle_title: "Measure angle",
        height_title: "Measure height difference",
        profile_title: "Profiles",
        kilometrierung_title: "Determine kilometry",
        kilometrierung_distance_title: "Measure on kilometer axis",
        gleisachse_distance_title: "Measure on track axis",
        gleisachse_gap_title: "Distance to track axis",
        inspect_title: "Geo Inspect",
        inspect_active_title: "Geo Inspect",
        tile_inspect_title: "Process Inspect",
        gnd_inspect_title: "Track Object Inspect",
        distance_help: "Set points by clicking, no further point is set when ending the measurement.",
        area_help: "Set corner points by clicking, no further point is set when ending the measurement.",
        volume_help: "Set base area by clicking, no further point is set when ending the measurement. " +
          "The calculation of the volume is based on an associated terrain model. " +
          "This may take a moment to complete.",
        volume_delta_help: "Set base area by clicking, no further point is set when ending the measurement. " +
          "The calculation of the volume difference is based on a associated terrain models. " +
          "This may take a moment to complete. " +
          "Comparison mode must be enabled to use this tool.",
        marker_help: "Set markers by clicking, no further point is set when ending the measurement.",
        angle_help: "Set a total of three points by clicking. This results in two lines that intersect at the second point. The angle between the lines is measured.",
        height_help: "Set points by clicking, no further point is set when ending the measurement.",
        profile_help: "Set points by clicking, no further point is set when ending the measurement. " +
          "The calculation of the profile is based on an associated point cloud.",
        kilometrierung_help: "Pick one of the loaded kilometry lines at first, then complete the kilometry measurement by clicking. " +
          "For another measurement, start picking the kilometry line again.",
        kilometrierung_distance_help: "Pick one of the loaded kilometry lines at first, then select a base point. " +
          "Afterwards, start measurements from the base point by picking the kilometry line again.",
        gleisachse_distance_help: "Pick one of the loaded track edges at first, then select a base point. " +
          "Afterwards, start measurements from the base point by picking the track edge again.",
        profile_along_axis_title: "Profile along the axis",
        profile_perpendicular_title: "Profile perpendicular to the axis",
        axis_measurement_value: "Axis measurement",
        axis_line_number: "Line",
        gleisachse_gap_2d_help: "First select one of the loaded track axes and calibrate its deviation: lay the green guide rails onto the rails in the orthophoto and click. Each click then measures the distance to the calibrated track axis.",
        gleisachse_gap_3d_help: "First select one of the loaded track axes. Each click then measures the distance from the point to the track axis.",
        gleisachse_gap_help: "Pick one of the loaded track edges at first and calibrate the deviation from the track axis. " +
          "Afterwards, select the track axis again and measure based on the deviation just calibrated.",
        /* inspect_help: "Am ausgewählten Punkt werden alle verfügbaren Bilder der aktivierten Prozesse angezeigt. " +
          "Durch Klicken auf diese Bildsymbole öffnet sich das Inspect-Fenster.",
        inspect_active_help: "Am ausgewählten Punkt werden alle verfügbaren Bilder aller verfügbaren Prozesse angezeigt. " +
          "Durch Klicken auf die Bildsymbole öffnet sich das Inspect-Fenster.", TODO */
        tile_inspect_help: "For the selected point, the displayed process is indicated.",
        gnd_inspect_help: "Clicking on track objects opens an Inspect window. " +
          "At least one track object layer must be active on the map to use this tool.",
        edit_help: "Edit the measurement by dragging and dropping the corner points. " +
          "The changes are automatically transferred to other viewers once editing is complete.",
        abort_changes: "Discard changes",
        apply_changes: "Apply changes",
        no_measurements: "There are no measurements yet.",
        menu: "Menu",
        base: "Basic functions",
        point: "Markers/Coordinates",
        height: "Height measurements",
        axis: "Axis measurements",
        inspect: "Inspect",
        active_measurement: "Measurement active",
        finish_measurement: "Finish measurement",
        finish_measurement_click: "Finish measurement via right click",
        annotation_name: "TEMPORARY: {{measurement}}",
        annotation_status: "Active",
        annotation_text: "Annotation Description",
        show: "Show {{profile_name}}",
        hide: "Hide {{profile_name}}",
        active: "active",
        create_annotation: "Create annotation",
        edit_measurement: "Edit measurement",
        delete_measurement: "Delete measurement",
        process_detected: "Detected process",
        no_process: "No data is activated here",
        date: "Date",
        process_id: "Process ID",
        process_type: "Processt Type",
        process_title: "Titel",
        process_description: "Description",
        alerts: {
          coming_soon: "Coming soon.",
          wrong_container: "Annotations can only be created from measurements generated on ortho-images or measurements transferred to ortho-images.",
          too_many_points: "At the moment, measurements to be converted into annotations may not contain more than 16 vertices. Please create a new measurement.",
          no_ortho: "To create an annotation, the measurement must be on an ortho-image.",
          need_compare: "In order to use this tool, the comparison function must be activated. " +
            "Right click to exit.",
          need_gnd: "In order to use this tool, at least one track object layer must be active on the map. " +
            "Right click to exit.",
          need_ortho: "At least one ortho image must be active to use the geoinspect feature.",
          need_2d: "This tool can only be used in a map. " +
            "Right click to exit.",
          need_3d: "This tool can only be used in a point cloud. " +
            "Right click to exit.",
          measurement_not_in_container: "The measurement selected for editing is in a different viewer.",
          measuring_in_other_container: "You are already working in a different viewer. " +
            "Right click to exit.",
          editing_in_other_container: "You are already working in a different viewer.",
        },
      },

      // Info Container
      ic: {
        collapse: "Collapse info container",
        expand: "Expand info container",
        rotate_north: "Map northing",
        rotate_45: "Rotate map by 45°",
        hide_view_cone: "3D-FOVs visible",
        show_view_cone: "3D-FOVs hidden",
        stop_axis_navigation: "End navigation on axis",
        start_axis_navigation: "Start navigation on axis",
        select_axis: "Please select track axis",
        cancel: "Cancel",
        forward: "Forward [(Ctrl+)(⇧+) X]",
        backward: "Backward [(Ctrl+)(⇧+) Y]",
        change_direction: "Change direction",
        next_pano: "↑ [.]",
        prev_pano: "↓ [,]",
        decouple: "View synchronized",
        couple: "View not synchronized",
        log_measurements: "Log Measurements",
        log_map: "Log Map",
        leave: "Leave Panorama",
        hide: "Pointclouds visible",
        show: "Pointclouds hidden",
        log_viewer: "Log Viewer",
        orbit: 'Camera Mode "Orbit"\n' +
          "Rotation around focus point\n" +
          "Movement in camera plane",
        earth: 'Camera Mode "Earth"\n' +
          "Rotation around click point\n" +
          "Movement in floor plane",
        ego: 'Camera Mode "First-Person"\n' +
          "Rotation around camera position\n" +
          "Movement in camera plane\n" +
          "- horizontally: arrow keys\n" +
          "- vertically: page up / down",
        top_down: 'Top view',
        down_top: 'Bottom view',
        side_front: 'Front view',
        side_back: 'Back view',
        side_left: 'Left view',
        side_right: 'Right view',
        profile: "Profile {{name}}",
        brightness: 'Brightness',
        intensity: 'Intensity',
        reset: "Reset to ground level",
        syncall: "Synchronize all movements",
        synctransl: "Synchronize translation/movement",
        syncrot: "Synchronize rotation",
        synczoom: "Synchronize zoom",
      },
    },

    support: {
      supportTittle: "Support",
      supportIntro: "Please check the <0>X2BIM Wiki</0> first if you have any questions or encounter any issues. There you will find helpful information, guides, and answers to frequently asked questions.",
      supportContact: "If you have technical or subject-specific questions, such as questions regarding project approvals, please contact the following support address: <0>{{email}}</0>",
      supportGeneral: "For general inquiries about X2BIM, please use the form below. Please describe your request in as much detail as possible and, if necessary, attach supporting files (PNG, JPG, or PDF).",
      message: "Message to X2BIM Support.",
      close: "Cancel",
      send: "Send",
      addFileTittle: "Add Files",
      sent: "Sent",
      failed: "Failed to send message",
    },

    changelogs: {
      title: "News"
    },

    customerSettings: {
      title: "Settings",
      geoServices: {
        title: "External Geo Services",
        add: "Add",
        empty: "No external geo services available.",
        createTitle: "Create Geo Service",
        editTitle: "Edit Geo Service",
        deleteTitle: "Delete Geo Service",
        deleteConfirm: "Are you sure you want to delete this geo service?",
        nameLabel: "Name",
        urlLabel: "URL",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        validationError: "Name and URL are required.",
        configValidationError: "The field \"{{field}}\" is required.",
        typeLabel: "Type",
        configSection: "Configuration",
        getCapabilities: "Get Capabilities",
        capabilitiesHint: "Enter the URL and click 'Get Capabilities' to load the configuration options.",
        capabilitiesSuccess: "Connection successful. Configuration options have been loaded.",
        capsFailed: "GetCapabilities failed",
        capsCorsFailed: "Connection failed. The server may not allow cross-origin requests (CORS).",
        config: {
          layers: "Layers",
          layer: "Layer",
          format: "Format",
          version: "Version",
          projection: "Projection",
          matrixSet: "MatrixSet",
          tmsY: "TMS Y-axis (Y=0 at bottom, inverted)",
        },
      },
    },

    leftNav: {
      dashboard: "All Projects",
      viewer: "Viewer",
      labeling3d: "3D-Labeling",
      sbb: "Clearance Inspector",
      betaViewer: "MapLibre Viewer",
      uploader: "Uploader",
      projects: "Projects",
      processes: "Processes",
      tools: "Tools",
      management: "Management",
      userManagement: "Users",
      language: "Language",
      help: "Help",
      faq: "FAQ",
      wiki: "Wiki",
      logout: "Logout",
      account: "Account",
      userManual: "User Manual",
      support: "Support",
      credit: "Controlling",
      finance: "iV Controlling",
      bim: "BIM Viewer",
      nextgen: "NextGen",
      customerSettings: "Settings",
    },

    accountSettings: {
      title: "User settings",
      userName: "User name",
      role: "Role",
      communicationEmail: "Contact email address",
      change: "Change",
      save: "Save",
      cancel: "Cancel",
      close: "Close",
      invalidEmail: "Please enter a valid email address",
      emailUpdated: "Contact email address updated",
      emailUpdateFailed: "Contact email address could not be updated",
      emailNotConfirmed: "This email address has not been confirmed yet.",
      newsletter: "Receive newsletter/updates",
      newsletterUpdated: "Newsletter preference updated",
      newsletterUpdateFailed: "Newsletter preference could not be updated",
      deleteAccount: "Delete account",
      deleteConfirm: "Do you want to request the deletion of your account? Our support team will contact you.",
      deleteRequested: "Deletion request sent",
      deleteFailed: "Deletion request could not be sent",
      news: "Receive news",
    },

    dashboard: {
      yourProject: "Your projects ({{count}})",
      overview: "Dashboard",
      noCustomerWarning: "You have not yet been assigned to any customers. Please contact your administrator.",
      noLinkedCustomer: "No customer linked",
      noProjectWarning: "No projects Assigned! Please reach out to the team!",
      search: "Search",
      projectCard: {
        processes: "Processes",
        showAll: "Show all"
      },
      table: {
        search: "Search",
        projectTitle: "Project Title",
        processCount: "Process Count",
        epsg: "EPSG",
        openInApp: "Open in App"
      },
      apps: {
        viewer: "Viewer",
        uploader: "Upload data",
        projects: "Projects",
        processes: "Processes",
      },
      jumpTo: "Jump to",
      pd: {
        selectionNeeded: "Please select a project first",
        deleteModalContent: "Do you want to delete the selected project and all related data? This action cannot be undone.",
        update: "Update",
        discard: "Discard changes",
        selection: "Selected Project",
        create: "Create",
        noProjectCreated: "The project could not be created",
        noProjectUpdated: "The project could not be updated",
        details: "Information",
        groupTitles: {
          generalInfo: "General information",
          controllingMetadata: "Controlling metadata",
          dataViewer: "Data viewer"
        },
        administration: {
          title: "Administration",
          processesText: "uploaded Processes",
          usersText: "assigned Users"
        },
        boundary: "Boundaries",
        defaultViewer: "Default viewer",
        viewerSettings: {
          title: "Viewer Settings",
          discontinuedWarning: "Warning: Process Sorting is deprecated and will be removed in the future.",
          processSortings: {
            title: "Process Sortings (Deprecated)",
            description: "Sets the default sorting for the visible processes in the viewer",
            selectedType: "Selected type",
            resetAll: "Reset all to default",
            sortBy: "Sort by",
            resetSelected: "Reset selected to default"
          }
        },
        pboundary: "{{- projectName}} Boundaries",
        pgnd: "{{- projectName}} GIS/Tracks",
        userAccess: "Project Permissions",
        createProject: "Create project",
        projects: "Projects",
        projectSelection: "Project Selection",
        projectUAcess: "{{- projectName}} Project Permissons",
        projectProcess: "{{- projectName}} Process List",
        projectProcessAccess: "{{- projectName}} Process Permissons",
        openProject: "Open",
        newProject: "Create project",
        uploadProjectImage: "Upload project image",
        projectCreateMessage: "Project created",
        projectName: "Project name",
        logoUploaded: "Project logo uploaded",
        logoLoaded: "Logo loaded",
        customerName: "Customer name",
        projCode: "Project code",
        projDuration: "Project duration",
        years: "Years",
        desc: "Project description",
        coord: "Project coordinate system",
        accounting: "Accounting",
        unallocatedAccount: "Unallocated account",
        accountAllocation: "Account allocation",
        fromCreditBalance: "Credit balance",
        plannedCredit: "Planned credit(s)",
        dataOwner: "Data owner",
        mmSize: "Mobile mapping size",
        pcSize: "Point cloud size",
        heliSize: "Helicopter size",
        flightArea: "Flight area",
        gigaPixel: "GigaPixel",
        uploadKML: "Upload KML",
        addKML: "Add KML",
        or: "OR",
        save: "Save",
        delete: "Delete",
        uploadKMLTitle: "Upload project KML",
        dragFile: "Drag file here",
        fileExplorer: "File menuBar",
        userRemoved: "User removed",
        userAdded: "User added",
        addUser: "Add user",
        addAccount: "Add account",
        editAccount: "Edit roles",
        inviteUser: "User not found",
        inviteOrProvisionUserMessage: "The user {{email}} does not exist on the platform. You have two options: you can provision the user temporarily until they perform their first login with a known identity provider, or you can send them an invitation to register with the x2bim.com identity provider.",
        provisionUserMessage: "The user {{email}} does not exist on the platform. You can provision the user temporarily until they perform their first login with their identity provider.",
        sendInvitation: "Send invitation",
        provisionUser: "Provision user",
        users: "Users",
        roles: "Roles",
        add: "Add",
        cancel: "Cancel",
        name: "Name",
        remove: "Remove",
        export: "Export",
        action: "Action",
        removeWarning: "Are you sure you want to delete the record?",
        projectCreate: "Create project",
        projectDelete: "Delete project",
        projectUpdate: "Update",
        gnd: "GIS/Tracks",
        layers: "Layers",
        layerType: "Layer type",
        editLayer: "Edit {{name}}",
        kilometerline: "Kilometerline",
        trackline: "Trackline",
        hectometerpoints: "Hectometerpoints",
        trackdataDbigo: "DB IGO track network data",
        kilometerLineSegment: "Route sections (kilometering)",
        trackEdgeSegment: "Track edges (stationing)",
        miscellaneous: "Miscellaneous",
        wms: "WMS Services (Experimental)",
        tracktopography: "SBB Tracktopography",
        Gleispunkte: "Track Points",
        tunnels: "Tunnels",
        tracks: "GTG-Strang-Namen",
        addNewLayer: "Add new layer",
        layerName: "Layer name",
        unnamedLayer: "Unnamed layer",
        layerColor: "Layer color",
        layerDimensions: "Layer dimensions",
        invalidHexString: "Invalid hex string",
        uploadError: "Unexpected error. Please try again later or contact us if the problem persists.",
        layerDeleteMsg: "Are you sure you want to delete this layer and all referenced objects?",
        edit: "Edit",
        noUploadsYet: "Looks like this layer has no uploads yet. Be the first to add one by using the red plus.",
        createNewUpload: "Create a new upload",
        deleteUpload: "Are you sure you want to delete this upload from {{date}} and all referenced objects?",
        deleteUploadTitle: "Uploaded GIS/tracks data '{{ uploadToDelete }}'",
        correspondingUploadedData: "Uploaded GIS/tracks data",
        newUpload: "New upload",
        forLayer: "for layer ",
        targetType: "Target type",
        inputFileSelection: "Input file selection",
        selectFile: "Select file",
        requiredEPSG: "Required EPSG: 3857",
        requiredEPSGDbigo: "Required EPSG: 4326",
        supportedGeometryTypes: "Supported geometry types: ",
        jsonNoFeatures: "GeoJSON must at least include one feature",
        jsonMultipleTypes: "GeoJson consists of multiple types. Only single type collections are allowed for now.",
        jsonUnsupportedType: `Unsupported geometry type {{unsupportedType}} in GeoJSON. Make sure to use one of Point or MultiLineString.`,
        gndAddTitle: "Add new objects",
        gndError: "Could not persist layer. Please try again later.",
        gndSuccess: "Successfully persisted layer. You can now manually display it in the viewer.",
        gndSubmit: "Add objects to layer",
        attributeMapping: "Attribute mapping",
        gndPointType: "Point Type",
        gndLineType: "Line Type",
        selectJson: "Select GeoJSON",
        gndNameKey: "Name Attribute",
        gndKmKey: "Km Attribute",
        gndLineKey: "Line-Number Attribute",
        gndTrackKey: "Track-Distinctive Attribute",
        gndKmStartKey: "Start-Km Attribute",
        gndKmEndKey: "End-Km Attribute",
        gndSimpleType: "Simple",
        gndKilometerizedType: "Kilometerized",
        gndGroups: "Groups",
        manageGndGroups: "Manage Layer groups and their visibility",
        gndGroupsCreate: "Layer group",
        noGroups: "No Layer groups available yet.",
        noLayerGroups: "No Layer group available.",
        editGroup: "Edit layer group",
        confirmDeleteGroup: "Are you sure you want to delete the layer group?",
        order: "Order",
        createGroup: "Create layer group",
        actions: "Actions",
        noLayers: "There are no layers yet. Create one using the red plus.",
        addLayerToGroup: "Add layer to group",
        layerGroupLabel: "Layer groups",
        createFirstGroup: "Create the first group",
        additionalAttributes: "Additional attributes",
        objectExport: "LRPO Export",
        deleteRoles: "Are you sure you want to remove this user from the customer?",
      },
      processes: {
        selection: "Selection",
        processes: "Process List",
        userAccess: "Process Permissions",
        procArchived: "Process deleted",
        procDeleted: "Process Deletion triggered! this operation may take some time to finish.",
        procArchivedFailed: "Failed to delete process",
        tableCompact: "Compact",
        tableFull: "Full",
        pID: "ID",
        pTitle: "Title",
        pDesc: "Description",
        pType: "Type",
        pStatus: "Status",
        all: "All",
        allWithoutDeleted: "All without deleted",
        pSourceDate: "Source Date",
        pInitDate: "Process Date",
        pTags: "Tags",
        actions: "Actions",
        actionsAdmin: "Admin Actions",
        actionsEdit: "Edit",
        downloadReport: "Download report",
        internal: "Internal",
        external: "External",
        standUser: "Standard User",
        standardUserAccess: "Access",
        grantStandardUserAccess: "Grant access for standard user",
        revokeStandardUserAccess: "Revoke access for standard user",
        usedStorageMB: "Used Storage",
        creditsConsumed: "Credits Consumed",
        usedStorageShort: "Storage",
        creditsConsumedShort: "Credits",
        archive: "Delete",
        close: "Close",
        addTagToProcess: "+ Add tag to process",
        selectOrCreateTag: "Select or create a tag",
        deleteProcessMsg: "Do you want to delete this process?",
        areYouSure: "Are you sure?",
        confirmText: "Are you sure you want to {{status}} standard-user access for {{count}} selected processes?",
        activate: "Activate selected",
        deactivate: "Deactivate selected",
        enableAccess: "enable",
        disableAccess: "disable",
        accessPermissionMissing: "You don't have permission to change process access.",
        accessFinishedOnly: "Only finished processes can have access changed.",
        processAccessGranted: "Viewing access for standard users to process '{{processTitle}}' was granted.",
        processAccessRevoked: "Viewing access for standard users to process '{{processTitle}}' was revoked.",
        bulkProcessAccessGranted: "Viewing access for standard users was granted for {{count}} selected processes.",
        bulkProcessAccessRevoked: "Viewing access for standard users was revoked for {{count}} selected processes.",
        processeCopy: "Copy",
        copyId: "Copy ID",
        idCopied: "Id Copied",
        copyText: "Project: {{projectName}} - copy to another project",
        copyPermissionMissing: "You don't have permission to copy processes.",
        copyFinishedOnly: "Only finished processes can be copied.",
        copyNoDestination: "No other project has a matching EPSG.",
        copyBackgroundNotice: "Copying runs in the background and may take several minutes.",
        copyDestination: "Destination: {{projectName}}",
        copyCredits: "Estimated cost: {{count}} credits",
        copyStarting: "Starting copy",
        copySuccessMessage: "Copying has started. This may take several minutes.",
        copyFailedMessage: "Could not start copying the process.",
        reparseSensors: "Recreate Sensors",
        reparseConfirmTitle: "Do you want to recreate the sensors?",
        reparseConfirmDescription: "These will be created based on existing data from the storage.",
        statusChanged: "Status Changed",
      },
      objectExport: {
        warning: "Something went wrong while getting process details!!",
        confirm: "Please Confirm?",
        confirm_text: `If you confirm this export, {{count}} object(s) will be exported.`,
        export: "Export",
        heading: "Wählen Sie einzelne Befahrungen aus, um Objekte an LIRA zu exportieren.",
        text: 'Exportierbar sind Objekte im Status "geschlossen". Es werden Ihnen nur Befahrungen angezeigt, die mindestens ein geschlossenes Objekt beinhalten.',
        p_disc: "Prozessierung",
        date: "Date",
        open: "open",
        closed: "closed",
        exported: "exported",
        noItem: "No objects to export at the moment!",
        exportButton: `Exportiere {{count}} processe(s)`,
        exportSuccessMessage: `Export of {{count}} object(s) started. This will take a few minutes. If objects were exported successfully, they will be in the state "exported".`
      }
    },

    homePage: {
      dashboardLink: "Go to App",
      platform: "About the plattform",
      impressum: "Legal Notice",
      datenschutz: "Data Protection",
      dataText: "Data From X Perspectives",
      point1: "Specialized in long distances and large-scaled projects",
      point2: "DSGVO-compliant anonymization using AI",
      point3: "Enterprise „Single Sign On“ (e.g. M365)",
      point4: "Computer vision / AI-based object recognition in 2D and 3D",
      point5: "Development of customer specific AI modules",
      point6: "Image data, orthoimages and point clouds",
      point7: "High-performance solution for processing 2D/3D data",
      point8: "Model (IFC) and plan (DWG) integration",
      point9: "UAV, helicopter, mobile mapping, BIM track network data",
      text1: "Measuring in 3 dimensions",
      text2: "Multitemporal data analysis",
      text3: "Track axis and kilometer functions",
      text4: "Multidimensional visualization",
      description: "Modern infrastructure projects require innovative solutions and new perspectives. " +
        "With X2BIM as a common platform for aerial surveys (UAS), terrestrial laser scan data and mobile mapping, you not only increase project efficiency, but also gain X new insights into your data. " +
        "Easily compare your CAD plans and BIM models with 3D point clouds or high-resolution ortho images on the web and monitor your construction site on site!",
      moreInfo: "More Information..",
    },

    //User Management
    um: {
      accounts: "User Accounts"
    },

    notify: {
      roleSuccess: "Roles saved",
      invitationSent: "Invitation sent successfully",
      invitationFailed: "Failed to send invitation",
      provisionFailed: "Failed to provision user",
      addUserFailed: "Failed to add user",
      maxUsersReached: "Maximum number of users reached for this customer",
      userAddedToCustomer: "User added to customer",
      rolesFailed: "Error saving Roles",
      userAlreadyInCustomer: "This user is already in the customer. To assign additional roles, use the edit action in the users table.",
      noActiveProject: "No active project",
      confirm: "Please confirm",
      confirmDeleteProjectMessage: "Are you sure you want to delete this project?",
      confirmAction: "Yes",
      cancel: "No",
    },

    messages: {
      loginErrorTittle: "Your session has expired, please login again!",
      loginError: "  Due to inactivity this session has ended! Please login again to access this page!",
      login: "Login",
      logOut: "Logout",
      pricingButton: "Prices",
      x2bimToInfraviewButton: "X2BIM to Infraview",
      requestADemoButton: "Request a Demo",
      agbsButton: 'ALB',
      notAllowed: "Not Allowed",
      notAllowedMessage: "You do not have appropriate access to visit this page!",
      goBack: "Go Back",
      apiError: "Failed to connect to server! Try again in a while!",
      tryAgain: "Try again",
      apiIssue: "Request failed with status {{statusCode}}.",
      errorTittle: "App Run into an Issue :( !", //TODO:
      progressSaved: "Progress saved",
      noActiveProject: "No active project!",
      onlyPNG: "Only PNG types of images are allowed to be uploaded, Please make sure the logo has the correct file format!",
    },

    uploadModal: {
      dropFileHere: "Drop file here",
      clickOrDrop: "Click to select or drop file here",
      selectFile: "Select file",
      parsingFailed: "File parsing failed",
      acceptedFileTypes: "Accepted file types: ",
    },

    credit: {
      transactions: "Transactions",
      projectClosed: "Closed Transaction by Project",
      projectOpen: "Open Transaction by Project",
      titleCustomer: "{{customer}}",
      titleCredits: "Credit balance: {{credit}}",
      noActiveCustomer: "No active customer! Please choose a customer from the left meni.",
      noTxns: "No executed transactions",
      consumptionDetails: "Consumption details per project",
      noProjectWiseConsumption: "No consumed credits",
      creditTxns: "Credit transactions",
      creditTxnsAll: "Credit transactions of all customers",
      balanceCustomers: "Credit balance per customer",
      txnDate: "Transaction date",
      creditIncome: "Credit income",
      creditConsumed: "Consumed credits",
      txnStatus: "Status",
      txnDescription: "Description",
      addedBy: "User",
      open: "Open",
      close: "Closed",
      project: "Project",
      consumedBy: " Consumed by",
      sum: "Sum",
      year: "Year",
      "January": "January",
      'February': "February",
      'March': "March",
      'April': "April",
      'May': "May",
      'June': "June",
      'July': "July",
      'August': "August",
      'September': "September",
      'October': "October",
      'November': "November",
      "December": "December",
      customerBalance: "Customer balance",
      consumptionPerCustomer: "Consumption per customer",
      addTxn: "Add new transaction",
      customer: "Customer",
      addTxnButton: "Add transaction",
      add: "Add",
      change: "Change",
      customerId: "Customer ID",
      txnType: "Transaction type",
      amount: "Amount",
      desc: "Description",
      negativeTxn: "Negative transactions",
      positiveTxn: "Positive transactions",
      balance: "Balance",
      CreditAdded: "Add credit",
      CreditRemoved: "Remove credit",
      credits: "Credit(s)",
      dateRange: "Date range",
      startDate: "Start date",
      endDate: "End date",
      apply: "Apply",
      trendcreditconsumption: "Trend credit consumption",
      trendView: "Trend",
      monthlyStackView: "Monthly stack",
      dailyStackView: "Daily stack",
      topCustomersView: "Top customers",
      creditConsumption: "Credit consumption",
      creditBalance: "Credit Balance",
      cr_txn: "Credit Transaktions",
      pleaseSelectDate: "Bitte wählen Sie ein Startdatum für die Anzeige der Prozessdaten.",
      monthlyView: "Monthly",
      procssControll: "Process Controlling",
      quickFilter: "Quick filter for Process Types and Date Range.",
      processType: "Process Type",
      selectAll: "Select All",
      startDate: "Start Date",
      endDate: "End Date",
      processOverview: "Process Overview",
      avgDurationMinutes: "Average Duration (Minutes)",
      avgDurationHours: "Average Duration (Hours)",
      noProcess: "No Data to display.",
      "processInsights": "Process Insights",
      table: "Table",
      chart: "Chart",
      userRanking: "User Ranking",
      status: "Status",
      processTitle: "Process Title",
      projectName: "Project Name",
      uploadDate: "Upload Date",
      uploadFinishDate: "Upload Finish Date",
      uploadedBy: "Uploaded By",
      topUploaders: "Top Uploaders",
      day: "Day",
      month: "Month",
      year: "Year",
      user: "User",
      period: "period",
      uploads: "Uploads",
      totalStorage: "Total Storage",
      processId: "Process ID",
      processName: "Process Type",
      storageGB: "Storage (GB)",
      filters: "Filters",
      allOption: "All",
      selectedCount: "{{count}} selected",
      clearSelection: "Clear selection",
      dateFrom: "Date From",
      dateTo: "Date To",
      creditConsumptionTrend: "Credit Consumption Trend",
      accumulated: "Accumulated",
      aggregated: "Aggregated",
      groupBy: "Group By",
      groupByStatus: "Status (Open/Closed)",
      timeWindow: "Time Window",
      noDataAvailable: "No data available for selected filters.",
      exportCsv: "Export CSV",
      collapseGroup: "Collapse group",
      expandGroup: "Expand group",
      ivProjectId: "iV Project ID",
      projectCode: "Project Code",
      accountAllocation: "Kontierungsziel",
      date: "Date",
      transactionType: "Transaction Type",
      processPID: "Process (PID)",
      runningBalance: "Running Balance",
      errorLoading: "Error loading dashboard: {{message}}",
      infrastructure: "Infrastructure",
      transactionsCount_one: "{{count}} transaction",
      transactionsCount_other: "{{count}} transactions",
    },

    notFound: {
      fourZeroFour: "404: Page not found",
      helpMsg: "You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation",
      goBackToStart: "Go back to start"
    },

    labeling: {
      abortSetClass: "Cancel",
      noEditingServiceActive: "No labeling service active",
      type: "Type",
      segment: "Segment",
      instance: "Instance",
      cut: "Cut",
      focusCut: "Focus Cut",
      toggleInsideOutside: "Toggle Cut Inside/Outside",
      toggleCutActive: "Activate/Deactivate Cut",
      handleDeleteCut: "Delete Cut",
      editLabel: "Edit Label",
      selectClass: "Select Class",
      editingLine1: "Polygon selection active: Set polygon points with left-click and finish with right-click.",
      editingLine2: "Mouse navigation is disabled during editing.",
      labeledObjects: "Labeled Objects",
      abortChanges: "Discard Changes",
      cancel: "Cancel",
      saveChanges: "Save Changes",
      deleteLabel: "Delete Label",
      addCut: "Add Cut",
      highlight: "Highlight the Label",
      highlightButton: "Highlight",
      onlyLabel: "Show Only the Label",
      onlyLabelButton: "Label only",
      changeClass: "Change Object Class",
      hideAllClasses: "Hide All",
      loadAllLabels: "Load All Labels in all cells",
      loadingLabels: "Loading…",
      showAllClasses: "Show All",
      choosePointCloud: "Select Point Cloud",
      availableClassesNr: "Available Object Classes",
      classes: "classes",
      resetView: "Reset View",
      addLabel: "+ Add Label",
      changePointCloud: "Change PointCloud",
      noPointClouds: "No point clouds :(",
      noPointCloudsSubtitle: "There are no point clouds available here. This is because no point clouds have been uploaded for this project, or they are not available for labeling.",
      noClasses: "No labeling classes :(",
      noClassesSubtitle: "There are no classes available for labeling here. This is because no classes have been assigned to this project yet.",
      loadingData: "Loading Data...",
      addCellLine1: "Cell Selection active: Click to select cell for Labeling.",
      stopAddingCells: "Finish",
      addCellLine2: "",
      prelabelClassIds: "Prelabeling",
      dialog: {
        confirmButton: "OK",
        cancelButton: "Cancel",
        deleteButton: "Delete",
        saveButton: "Save",
        errorTitle: "Error",
        warningTitle: "Warning",
        successTitle: "Success",
        confirmTitle: "Confirm",
        deleteCellTitle: "Delete Cell",
        deleteCellMessage: "Delete {{cellName}} and ALL labels in the cell?",
        changeCellDimensionsTitle: "Change Cell Dimensions",
        changeCellDimensionsMessage: "Change the dimensions of {{cellName}}? Existing labels are not modified.",
        changeCellDimensionsErrorMessage: "The cell dimensions could not be saved.",
        noCellSelectedTitle: "No Cell Selected",
        noCellSelectedMessage: "Please select a cell first to import floating labels.",
        noFloatingLabelsTitle: "No Floating Labels",
        noFloatingLabelsMessage: "No labels without cell attribution found.",
        cellErrorTitle: "Cell Error",
        cellErrorMessage: "Selected cell has no ID. Cannot import labels.",
        systemErrorTitle: "System Error",
        bboxHandlerErrorMessage: "Bounding box handler not initialized.",
        pointCloudErrorMessage: "Point cloud handler not available.",
        pointCloudLoadErrorMessage: "The point cloud could not be loaded. Please try again.",
        importFloatingLabelsTitle: "Import finished",
        importFloatingLabelsSummary: "Imported {{importedCount}} of {{totalCount}} floating label(s).",
        importFloatingLabelsImportedSection: "Imported:",
        importFloatingLabelsSkippedSection: "Skipped:",
        importFloatingLabelsFailedSection: "Failed:",
        importFloatingLabelsNoPointsReason: "No points found for label",
        importFloatingLabelsNoOverlapReason: "No overlap with selected cell",
        importFloatingLabelsObbFailedReason: "Failed to calculate oriented bounding box",
        importFloatingLabelsUnknownErrorReason: "Unknown error",
      },
      instanceOverview: "Instance Overview",
      updating: "Saving...",
      cellOverview: "Cell Overview",
      cellAddition: {
        title: "Add Cell manually",
        manual: "Import Cells from GeoJSON",
        titleManual: "Import Cells from GeoJSON",
      },
      cellDimensions: {
        title: "Edit Cell Dimensions",
        description: "Drag the handles of the cell box in the scene to resize it.",
        apply: "Apply",
        cancel: "Cancel",
      },
      cellImport: {
        title: "Import Cells from GeoJSON",
        dropzoneTitle: "Drop a GeoJSON file here",
        dropzoneSubtitle: "or click to select a file (.geojson / .json)",
        totalFeatures: "Total features",
        pointFeatures: "Point features",
        polygonFeatures: "Polygon features",
        cellsToCreate: "Grid cells to import",
        overlappingCells: "Overlapping existing cells",
        allOverlappingWarning: "All grid cells overlap existing cells – nothing to import.",
        allNoZWarning: "No point cloud data found in any grid cell – nothing to import. Check Coordinate Reference System!",
        allBlockedMixedWarning: "All grid cells are either overlapping existing cells or contain no point cloud data.",
        importResultTitle: "Import complete",
        importResultSuccess: "{{count}} cell(s) imported successfully.",
        importResultPartial: "{{imported}} cell(s) imported, {{failed}} failed.",
        noZWarning: "No Z coordinates found – elevation will be estimated from existing cells.",
        noPolygonsWarning: "No polygon features found. Only polygons are converted to cells.",
        invalidFile: "Invalid or unsupported GeoJSON file.",
        confirmImport: "Import {{count}} Cell(s)",
        selectDifferentFile: "Select different file",
        cancel: "Cancel",
      },
      grid: {
        cellTitle: "Cell {{name}}",
        advanced: "Advanced",
        unsaved: "Unsaved",
        comment: "Comment",
        classFilter: "Class filter",
        cellAction: "Cell action",
        unsavedChangesConfirm: "You have unsaved changes. Leave without saving?",
        unsavedChangesTooltip: "Unsaved changes – save or discard before leaving",
        previousCell: "Previous cell",
        nextCell: "Next cell",
        cellCommentPlaceholder: "Cell comment\u2026",
        importFloatingLabels: "Import labels without cell assignment",
        deleteCell: "Delete Cell",
        editCellDimensions: "Edit Cell Dimensions",
        boundingBoxes: "Bounding Boxes",
        showBoundingBoxes: "Show bounding boxes",
      },
      gridTab: {
        filter: "Filter",
        status: "Status",
        statusOpen: "Open",
        statusClosed: "Closed",
        statusConfirmed: "Confirmed",
        activeFilters: "{{count}} active",
        classFilter: "Class filter",
        options: "Options",
        colorPointCloud: "Color point cloud",
        cellCount: "{{visible}} / {{total}} Cells",
        noCellsSaved: "No cells saved yet. Click \"Add Cell\" to enable the grid view and select cells in the point cloud.",
        labelsNotLoadedYet: "Labels not loaded yet.",
        prelabeling: "Pre-labeling Mapping",
        managePrelabeling: "Manage Pre-labeling",
        experimental: "Experimental",
      },
      prelabeling: {
        subtitle: "Map point-cloud classification integers to semantic classes.",
        classCol: "Class",
        idsCol: "Classification IDs",
        idsTooltip: "Point-cloud classification integers that map to this class",
        invalidIds: "Positive integers only, comma-separated",
        activate: "Activate mapping",
        deactivate: "Deactivate mapping",
        activeSummary: "{{count}} of {{total}} classes active",
        noClasses: "Classes not yet loaded.",
      },
      toolbar: {
        points: "Points",
        kPoints: "{{value}}k points",
        coloring: "Coloring",
        label: "Label",
        classification: "Classification",
        highlight: "Highlight",
        legend: "Legend",
        reset: "Reset",
        pointSize: "Point Size",
        projection: "Projection",
        orthographicCamera: "Orthographic camera",
        perspectiveCamera: "Perspective camera",
        orthographicOrbitOnly: "Earth mode is not available in orthographic projection",
        camera: "Camera",
        background: "Background",
        gradientBackground: "Gradient background",
        whiteBackground: "White background",
        skyboxBackground: "Skybox background",
      },
      selected: {
        unselect: "Unselect",
        previous: "Previous",
        first: "First",
        focus: "Focus",
        edit: "Edit",
        next: "Next",
        last: "Last",
      },
      hotkeys: {
        classPicker: "Hotkeys: Press the shown class key to select a class.",
        gridReview: "Hotkeys: Space - Add label\nLeft/Right - Previous/Next label",
        labelEditing: "Hotkeys:\nSpace - Add cut\nS - Save\nEsc - Back (after save)",
      },
      pointCloud: {
        labelCount: "{{count}} Label",
        labelCount_plural: "{{count}} Labels",
      },
      cell: {
        size: "Size: {{x}} \u00d7 {{y}} \u00d7 {{z}}",
        buffer: "Buffer: {{value}}",
        labelCount: "{{count}} Label",
        labelCount_plural: "{{count}} Labels",
        duplicateName: "Duplicate – another cell shares this name",
      },
      // AIObjectClass display names, keyed by the class' ascii nameKey
      classNames: {
        surface_soil: "Surface/Soil",
        vegetation_low: "Vegetation - Low",
        vegetation_medium: "Vegetation - Medium",
        vegetation_high: "Vegetation - High",
        building: "Building",
        noise_high: "Noise (High)",
        noise_vehicle: "Noise (Vehicle)",
        motor_bicycle: "Motorcycle/Bicycle",
        bus_truck: "Bus/Truck",
        car: "Car",
        bar_structure: "Bar Structure",
        person_single: "Person (Single)",
        noise_people: "Noise (People)",
        wall_fence: "Wall/Fence",
        structure: "Structure",
        exclude: "Exclude",
        wire: "Wire",
        signal_sperrsignal: "Signal - Sperrsignal",
        signal_hv_haupt: "Signal - H/V Main",
        signal_hv_vor: "Signal - H/V Distant",
        pzb_magnet: "PZB Magnet",
        lst_sonstige: "LST Other",
        mast_sonstige: "Mast - Other",
        mast_ola: "Mast - Catenary",
        mast_signal: "Mast - Signal",
        schiene: "Rail",
        gleisbett: "Track Bed",
        laermschutzwand: "Noise Barrier",
        ueberfuehrung: "Overpass",
        rollmaterial: "Rolling Stock",
        signal_ks: "Signal - Ks",
        sperrmaennchen: "Blocking Marker",
        ola_structure: "Catenary Structure",
        signal_structure: "Signal Structure",
        signalbruecke: "Signal Bridge",
        signal_fragment: "Signal Fragment",
        x_an_signal: "X on Signal",
        bahnsteig: "Platform",
        zwergsignal: "Dwarf Signal",
        vegetation_hoch: "Vegetation (High)",
        gebaeude: "Building",
        noise: "Noise",
        vegetation_mittel: "Vegetation (Medium)",
        vegetation_niedrig: "Vegetation (Low)",
        verbotsschild: "Prohibition Sign",
        bauwerk: "Structure",
        stabbauwerk: "Bar Structure",
      },
    },
    pricing: {
      mainTitle: 'X2BIM Pricing',
      included: 'Included',
      additionalUser: 'Additional User',
      includedCredits: 'Included Credits',
      creditCost: 'Credit Cost',
      inclProcessAndHosting: '(Incl. Processing and Hosting)',
      concurrProcessPipelines: 'Concurrent Processing Pipelines',
      tierButton: 'Get Started',
      tier: 'Tier',
      credits: 'Credits',
      'Order Access': 'Order Access',
      'Tools': 'Tools',
      'Updates': 'Updates',
      'Support': 'Support',
      'Unlimited Projects': 'Unlimited Projects',
      'SSO': 'Single Sign On',
      'Unlimited Users*': 'Unlimited Users*',
      "User Management": "User Management",
      "CAD, GIS and BIM Integration": "CAD-, GIS- and BIM-Integration",
      "Achsenwerkzeuge": "Axis Tools",
      "Nutzersupport": "User Support",
      "Premium support​": "Premium Support",
      table: {
        title: 'Credits',
        subTitle: "Credits sind die plattforminterne Einheit zur Verrechnung einzelner Datenprozessierungsschritte, sowie für den Speicherbedarf.",
        header: ['Position', 'Description', 'Unit', 'Credits per Unit'],
        content: [
          { position: '1', description: 'UAV/Survey Data', unit: '1 GigaPixel (Gpix)', creditsPerUnit: '1000' },
          { position: '2', description: 'Point Clouds (including panoramic images)', unit: '1 Gigabyte (GB)', creditsPerUnit: '200' },
          { position: '3', description: 'General storage costs (per month)*', unit: '1 Gigabyte (GB)', creditsPerUnit: '5' },
          { position: '4', description: 'AI/Object Recognition *', unit: '-', creditsPerUnit: '-' },
          { position: '5', description: 'Plan Import (Geotiff, DXF)', unit: 'per process', creditsPerUnit: '250' },
          { position: '6', description: 'IFC Model', unit: 'per process', creditsPerUnit: '250' },
          { position: '7', description: 'Setup Single-Sign On Setup**', unit: 'one-time', creditsPerUnit: '-' }
        ],
        note: 'Note: *Only available in combination with Advanced or Enterprise tier',
      },
      calculator: {
        title: 'Calculation Help',
        calculationHelper: 'Input data',
        subTitle: 'Calculate how any extra credits per month you need.',
        selectATier: 'Select a Tier:',
        tiers: ['Basic', 'Advanced', 'Enterprice'],
        noFlightsPerMonth: 'No. Flights / mo',
        noPhotosPerFlight: 'No. Photos / Flight',
        megapixels: 'Megapixels',
        creditsIncluded: 'Credits included in {{tier}} tier',
        creditsPerMonth: 'credits/mo',
        extraCreditsPerMonth: 'Extra credits needed per month:',
        imageProcessing: {
          title: 'Calculate the additional monthly credits required for your image processing needs.',
          knownDataQuestion: "Is the average monthly amount of flight data (UAV) in gigapixels known?",
          dataAmountInGigapixels: "* Data volume in gigapixels",
          gigapixelCalculator: "Gigapixel Calculator",
          externalOrthophotosQuestion: "Do you have external orthophotos (e.g. helicopter data)?",
          pointCloudDataKnownQuestion: "Do you have external point clouds (e.g. terrestrial laser scanners)?",
          pointCloudDataKnownQuestionSize: "Abschätzung der Größe von Punktwolken:",
          dxfPlanVolume: "DXF Unit(s)",
          dxfPlanDataKnownQuestion: "Do you have CAD plans (DXF) for integration into X2BIM?",
          ifcModelsQuantityKnownQuestion: "Do you have BIM models (IFC) for integration into X2BIM?",
          pointCloudDataKnownQuestionPointSize: "Estimation of the size of point clouds:",
          storageInMonthsQuestion: "Estimated duration of data storage (in months):",
          numberOfUsersQuestion: "Number of users:",
          singleSignOnSetupQuestion: "Single Sign-on Setup (Available only for Advanced and Enterprise)",
          singleSignOnSetupCost: "Single Sign-on Setup costs a one-time fee of 5000 Euros, including a custom subdomain (e.g. htttps://kundenname.x2bim.com)"
        },
        storage: {
          title: 'Calculate the additional monthly credits required for your storage needs.',
          numberOfUsersQuestion: "Number of users:",
          storageInMonthsQuestion: "Estimated duration of data storage (in months):",
          storageInMonthsQuestionHint: "Der Speicherbedarf in Credits ergibt sich aus einer angenommenen linearen Verteilung der verarbeiteten Daten und stellt nur eine grobe Schätzung dar."
        },
        userAccess: {
          singleSignOnSetupQuestion: 'Calculate the additional monthly credits required for your user access needs.',
          numberOfUsersQuestion: "Number of users:",
        },
        pointCloudProcessing: {
          title: 'Calculate the additional monthly credits required for your point cloud processing needs.',
        },
        yourCosts: 'Monthly Credits and Costs',
        result: {
          totalFlights: 'Amount of flight data (UAV)',
          externalOrthophotos: 'External orthophotos (e.g. helicopter data)',
          externalPointClouds: "External point clouds (e.g. terrestrial laser scanners)",
          cadPlans: "CAD plans (DXF) for integration into X2BIM",
          bimModels: "BIM models (IFC) for integration into X2BIM",
          dataStorageDuration: "Estimated duration of data storage ",
          numberOfUsers: "Number of users",
          pointCloudProcessingCosts: "Total credits",
          singleSignOnSetup: "Single Sign-on Setup",
        },
        description: "Description",
        priceIndication: "Price Indication*",
        month: "Month",
        total: "Total",
        ssoExclusion: "* Setup of Single Sign-on is excluded from this and will be charged separately.",
        secondMonthOnwardsDetails: "** Price indication based on the assumption that credits from the one-time balance have been fully used.",
        firstMonth: "First Month",
        secondMonthOnwards: "Second Month Onwards"
      }
    },

    // BIM Viewer
    bim: {
      ifcInstruction: "IFC | Shift+Click for Multi Select",
      reset: "Reset",
      isolate: "Isolate",
      hide: "Hide",
      inspect: "Inspect",
      compare: "Compare",
      collab: "Collab",
      measurement: "Measure",
      layerManagement: "Layer Management",
      layerManagementDropHere: "Drag a layer here",
      layerOpacity: "Opacity",

      // ACC File Browser
      acc: {
        title: "ACC File Import",
        login: "ACC Login",
        loggedIn: "Successfully connected to your Autodesk account.",
        connectToACC: "Connect to Autodesk Construction Cloud (ACC)",
        pleaseLogin: "Please log in to browse your ACC Hubs and Projects.",
        loginWithAutodesk: "Login with Autodesk",
        checkingStatus: "Checking Status...",
        authenticationError: "Authentication Error",
        selectHub: "Select a Hub",
        selectHubTitle: "Select Autodesk Hub",
        selectProject: "Select Project in",
        selectProjectTitle: "Select ACC Project",
        back: "Back",
        up: "Up",
        noHubsFound: "No hubs found.",
        noProjectsFound: "No projects found.",
        folderEmpty: "This folder is empty.",
        import: "Import",
        logoutFromACC: "Logout from ACC",
        confirmImport: "Confirm File Import",
        confirmImportText: "You are about to initiate the import of",
        confirmImportDetails: "from",
        confirmImportNote: "The file will be downloaded by our server using a signed URL, processed through the IFC chain, and then imported into the platform.",
        cancel: "Cancel",
        confirmImportButton: "Confirm Import",
        importInitiated: "Import for *{{fileName}}* initiated! You will be notified when processing is complete.",
        importFailed: "Import for *{{fileName}}* failed to start.",
        importError: "Import error: {{error}}",
        sessionExpired: "Session expired. Please log in again.",
        hubFetchFailed: "Failed to fetch ACC Hubs.",
        projectFetchFailed: "Failed to fetch projects for the selected Hub.",
        fileStatus: {
          notImported: "Not Imported",
          upToDate: "Up-to-Date",
          outdated: "Outdated"
        }
      },

      // BIM Collaboration
      bimcollab: {
        login: "Login",
        successfullyLoggedIn: "Successfully logged in.",
        updateInformation: "Update Information",
        logout: "Logout",
        logoutFromBimCollab: "Logout from BIMCollab",
        pleaseConnect: "Please connect to BIMCollab to continue.",
        connectToBimCollab: "Connect To BimCollab",
        projectInformation: "Project Information",
        projectName: "Project Name",
        noProjectInfo: "No project information available",
        topics: "Topics",
        noTopicsAvailable: "No topics available",
        newIssue: "New Issue",
        createNewIssueText: "Create a new Issue in this project.",
        createNewIssue: "Create New Issue",
        createIssue: "Create Issue",
        saveChanges: "Save Changes",
        title: "Title",
        status: "Status",
        type: "Type",
        priority: "Priority",
        description: "Description",
        assignedTo: "Assigned To (Email)",
        dueDate: "Due Date",
        topicMetadata: "Topic Metadata",
        createdBy: "Created By",
        createdDate: "Created Date",
        modifiedBy: "Modified By",
        modifiedDate: "Modified Date",
        labels: "Labels",
        comments: "Comments",
        addComment: "Add a comment...",
        send: "Send",
        noCommentsYet: "No comments yet",
        viewportSnapshot: "Viewport Snapshot",
        viewpointSnapshot: "Viewpoint Snapshot",
        noSnapshotAvailable: "No Snapshot Available",
        captureSnapshot: "Capture Snapshot",
        retakeSnapshot: "Retake Snapshot",
        additionalViewpoints: "Additional Viewpoints",
        issue: "Issue",
        tableFilters: "Table Filters",
        availableColumns: "Available Columns",
        selectedColumns: "Selected Columns",
        add: "Add",
        remove: "Remove",
        showFilters: "Show Filters",
        edit: "Edit",
        repositionTooltip: "You can select one item to reposition.",
        statusValues: {
          active: "Active",
          open: "Open",
          inProgress: "In Progress",
          resolved: "Resolved",
          closed: "Closed"
        },
        typeValues: {
          issue: "Issue",
          fault: "Fault",
          clash: "Clash",
          request: "Request",
          inquiry: "Inquiry"
        },
        priorityValues: {
          critical: "Critical",
          high: "High",
          major: "Major",
          normal: "Normal",
          minor: "Minor",
          low: "Low"
        }
      },

      // BIM Viewer Top Panel
      topPanel: {
        catalog: "Catalog",
        layerMenu: "Layer menu",
        unnamedProject: "Unnamed Project",
        threeDView: "3D-View",
        viewerScene: "Viewer Scene",
        fov: "FOV",
        small: "small",
        large: "large",
        pointCloud: "Point Cloud",
        pointSize: "Point Size",
        pointBudget: "Point Budget",
        low: "low",
        high: "high",
        opacity: "Opacity",
        bimModels: "BIM-Models",
        resetView: "Reset View",
        resetAll: "Reset All",
        // Palette popover: theme, 3D background and text size
        appearance: {
          theme: "Theme",
          background: "3D Viewer Background",
          textSize: "Text Size",
          themes: {
            dark: { label: "Dark Mode", description: "Standard BIM viewer theme" },
            highContrastDark: { label: "High Contrast Dark", description: "Dark with maximum contrast (WCAG AAA)" },
            highContrastLight: { label: "High Contrast Light", description: "Light with maximum readability" }
          },
          backgrounds: {
            gradient: { label: "Gradient", description: "Standard BIM viewer background" },
            black: { label: "Black", description: "Full black background" },
            white: { label: "White", description: "Full light background" }
          },
          textSizes: {
            small: { label: "Small", description: "Compact – 13 px" },
            medium: { label: "Medium", description: "Standard – 16 px" },
            large: { label: "Large", description: "Improved readability – 20 px" }
          }
        }
      },

      // BIM Viewer pinned tools (the row above the bottom nav bar)
      tools: {
        cameraFrustums: "Camera stations",
        cameraFrustumsFocus: "Zoom to all cameras",
        cameraFrustumImages: "Show photos on camera planes",
        cameraFrustumCount: "{{count}} cameras",
        cameraFrustumLoading: "Loading cameras…",
        cameraFrustumNone: "No flight with photos loaded",
        cameraFrustumFlights: "Flights",
        photoLookupPick: "Find photos of a point — click a spot in the scene",
        photoLookupCount: "{{count}} photos show this point",
        photoLookupEmpty: "No photo shows this point",
        photoLookupHint: "Pick a point in the scene to see which photos show it.",
        photoLookupClose: "Close",
        cameraViewTitle: "Inside photo · {{name}}",
        cameraViewHint: "Drag to look around. Moving away leaves this view.",
        cameraViewOpacity: "Photo opacity",
        cameraViewExit: "Exit",
        cameraViewPrevious: "Previous photo",
        cameraViewNext: "Next photo",
        panoramaViewTitle: "360° · {{name}}",
        panoramaViewHint: "Drag to look around. Click the ground to move to a nearby panorama.",
        panoramaViewExit: "Exit",
        panoramaViewPrevious: "Previous panorama",
        panoramaViewNext: "Next panorama",
        panoramaViewOpacity: "Point cloud opacity",
        panoramaViewColorAdjustments: "Image adjustments",
        clipScene: "Clip Scene",
        clipDimensions: "Dimensions",
        clipRotation: "Rotation",
        clipInvert: "Invert clip",
        clipGhostPersistent: "Always show clipped-away context",
        clipSlice: "Slice mode",
        clipSliceAxis: "Axis",
        clipPosition: "Position",
        clipThickness: "Thickness",
        clipPin: "Pin panel",
        clipUnpin: "Unpin panel",
        clipFollowCamera: "Camera follows slice",
        clipHandles: "Face and rotation handles",
        clipViewAlong: "View along {{axis}}",
        clipLinePicking: "Click an axis in the 3D scene … Esc or another click cancels",
        clipLineSelect: "Slice along an axis – click, then pick the axis in the 3D scene",
        clipLineReady: "Start slicing along axis {{label}}",
        clipLineActive: "Slicing along axis {{label}} – click to pick another axis",
        clipLineWidth: "Width",
        clipFitView: "Fit box to current view",
        clipFitModel: "Fit box to whole model",
        clipCloseProfile: "Close height profile",
        clipOpenProfile: "Open height profile",
        clipOpenProfileUnavailable: "Height profiles require a vertical, non-inverted X or Y slice",
        profileWidth: "Profile width",
        profileOpenSlice: "Show as 3D slice",
        profileOpenSliceUnavailable: "3D slices require a loaded scene",
        clipNudgeHint: "Step by {{step}}.\nHold Shift for {{fine}}, Alt for {{coarse}}.\nHold the arrow down to repeat, faster the longer you hold.\nOr click the number to type an exact value.",
        clipPrecisionHint: "Drag a slider for coarse changes.\nShift + drag — fine, 1 m per pixel.\nAlt + drag — extra coarse.\nArrows step by one notch; Shift ▸ 1 m, Alt ▸ ten notches.\nClick a number to type an exact value.\nIn the scene: drag a corner to resize, Shift to move the box, Alt for a fine drag."
      },

      // BIM Compare
      compareUI: {
        opacityBlend: "Opacity Blend",
        model: "Model",
        selectInfo: "Select both a Target and a Reference and then activate the Compare and Deviation features.",
        bimModels: "BIM Model(s)",
        pointClouds: "Point Cloud(s)",
        selectAll: "Select All",
        compare: "Compare",
        stopCompare: "Stop Compare",
        selectColors: "Select Colors",
        colorByDeviation: "Color by Deviation",
        deviation: "Deviation",
        deviationDistance: "Deviation distance",
        absolute: "Absolute",
        signed: "Signed",
        coloring: "Coloring"
      },

      // IFC Structure
      structure: {
        clickToView: "Click an object to view its properties",
        multiselect: "Multiselect: {{count}} Selected",
        noPropertiesAvailable: "No properties available."
      },

      // Window Controls
      window: {
        dockLeft: "Dock Left",
        dockRight: "Dock Right",
        undock: "Undock",
        hideDock: "Hide panel",
        showDock: "Show panel",
        close: "Close Window"
      },

      // Add Data Modal
      addData: {
        title: "Add Model or Pointcloud",
        search: "Search",
        showAll: "Show all",
        ifcModels: "IFC Models",
        pointclouds: "Pointclouds",
        orthophotos: "Orthophotos",
        plans: "Plans",
        geoServices: "Geo services",
        gndLayers: "GIS/GND",
        cadSublayers: "Layers",
        addTo: "Add to {{target}}",
        removeFrom: "Remove from {{target}}",
        gnd2dHeightsHint: "2D layer without heights: they are approximated from the point cloud, and it is shown only where there is one.",
        layoutSwitched: "Switched to the 3D + 2D view",
        undo: "Undo",
        importFromACC: "Import/Update from ACC",
        monitoringDashboard: "Monitoring Dashboard",
        noFilesFound: "No files found matching your criteria.",
        noFilesAvailable: "No files are available.",
        autoLoad: "Auto-load in view",
        autoLoadHint: "Automatically loads every resource in this category that matches the current filters and whose footprint lies within the map view. The set updates as you pan the map or change the filters. Each category has its own toggle and keeps loading in the background once enabled.",
        processId: "Process ID",
        inMapExtent: "Map extent",
        mapExtentTooltip: "Limits the list to resources whose footprint overlaps the current map view.",
        byDataType: "By data type",
        bySensorType: "By sensor type",
        viewerSettings: "Viewer settings",
        selectAll: "Select all",
        deselectAll: "Deselect all",
        ifcNotAutoLoadable: "IFC models have no map extent and cannot be auto-loaded.",
        showProcessCluster: "Show process clusters",
        dataTypes: "Data types",
        mapReference: "Map reference",
        uploadTags: "Upload tags",
        autoLoadedGroup: "Auto-loaded",
        uav: "UAV",
        mobileMapping: "MobileMapping (MSP)",
        catalogTitle: "Catalog",
        allData: "All data",
        tabOrthos: "Orthos",
        typeOrtho: "Ortho",
        dems: "DSM",
        typeDem: "DSM",
        panoramas: "360° images",
        typePanorama: "360°",
        helicopter: "Helicopter",
        datasetAdd: "All",
        datasetRemove: "Remove",
        datasetPartialHint: "{{added}} of {{total}} parts added — click to add the rest",
        unavailable: "Unavailable",
        addFailedRetry: "Could not be loaded — click to try again",
        typePointcloud: "Point cloud",
        typeIfc: "IFC model",
        typePlan: "Plan",
        typeGeoservice: "Geo service",
        typeGnd: "GIS/GND",
        configurations: "Configurations",
        configurationsMock: "Sample configurations (mock) — applying a configuration follows once the backend is available.",
        autoLoadSelect: "Load data automatically?",
        moreActions: "More actions",
        showProcessesInDashboard: "Show processes in dashboard",
        sortByDate: "Sort by date",
        sortByTitle: "Sort by title",
        sortByDescription: "Sort by description",
        sortReversed: "Order reversed",
        searchShort: "Search",
        inMapExtentChip: "in map view",
        onlyActive: "active resources only",
        moreFilters: "More filters",
        removeAllLayers: "Remove all layers",
        resourceCount_one: "({{count}} resource)",
        resourceCount_other: "({{count}} resources)",
        noTitle: "No title",
        noDescription: "No description",
        noDate: "No date",
        collapseSidebar: "Collapse sidebar",
        expandSidebar: "Expand sidebar",
        addAll: "Add all",
        removeAll: "Remove all",
        zoomTo: "Zoom to",
        collapse: "Collapse",
        expand: "Expand",
        filterDate: "Date:",
        filterTags: "Tags:",
        filterType: "Type:",
        resetAll: "Reset all",
        selectedSuffix_one: "resource selected",
        selectedSuffix_other: "resources selected",
        download: "Download",
        downloadComingSoon: "Downloading isn't available yet.",
        addSelected: "Add",
        addedToast_one: "{{count}} resource added",
        addedToast_other: "{{count}} resources added"
      },

      layerMenu: {
        title: "Layer menu",
        search: "Search",
        filter: "Filter",
        openCatalog: "Open catalog",
        empty: "No layers added yet:",
        noMatches: "No matching layers",
        section3d: "3D",
        hide: "Hide",
        show: "Show",
        remove: "Remove",
        removeDataset: "Remove all parts",
        showAll: "Show all parts",
        keep: "Keep layer",
        dragToReorder: "Drag to change the draw order or move to another map",
        selectedCount_one: "{{count}} layer selected",
        selectedCount_other: "{{count}} layers selected",
        display: "Display",
        cadLayers: {
          notLoaded: "Layers are read from the map and appear once the drawing is visible in the map view.",
          fromView: "Layers from the map areas viewed so far. More appear as you pan and zoom."
        },
        toggleList: {
          search: "Search",
          noMatches: "No matches",
          showEmpty_one: "Show {{count}} without data",
          showEmpty_other: "Show {{count}} without data",
          hideEmpty: "Hide those without data"
        },
        ifcStyle: {
          surface: "Model",
          wireframe: "Wireframe",
          color: "Color",
          grey: "Gray",
          white: "White"
        },
        pointcloudStyle: {
          rgba: "RGB",
          intensity: "Intensity",
          intensityGradient: "Intensity gradient",
          elevation: "Elevation",
          color: "Single color",
          classification: "Color by classification",
          gamma: "Gamma",
          brightness: "Brightness",
          contrast: "Contrast",
          elevationRange: "Elevation range",
          elevationInterval: "Elevation interval",
          intervalBase: "Reference height",
          interval: "Interval",
          classes: "Classes",
          classVisibilityHint: "Showing and hiding applies to all point clouds",
          pickColor: "Pick color",
          reset: "Reset"
        }
      },

      // GLB Root View
      glbRoot: {
        legacyIFC: "Legacy IFC",
        unnamed: "Unnamed",
        expandAll: "Expand All",
        collapseAll: "Collapse All",
        resetSelection: "Reset Selection ({{count}})",
        model: "Model {{number}}"
      },

      // Map View
      mapView: {
        miniMapTitle: "2D Map",
        view3d: "3D View",
        viewMini: "3D + 2D Mini Map",
        viewSplit: "Split View (3D & 2D)",
        viewTSplit: "T-Layout (3D + 2×2D)",
        viewMap: "2D Map",
        viewComparator: "Map Comparator",
        syncTitle: "Synchronisation 2D/3D",
        syncPosition: "Sync movement",
        syncRotation: "Sync rotation",
        syncZoom: "Sync zoom",
        syncAll: "Sync all"
      }
    },

    lrp: {
      resumeSurvey: {
        title: "Would you like to continue editing the last inspection?",
        openLastSurvey: "Open last inspection",
        goToMap: "To the map",
        error: "The last survey could not be opened. Please try again or go to the map.",
      },
      profileInfo: {
        startMeasurement: "Start measurement (D)",
        stopMeasurement: "Stop measurement",
        showProfile: "Show profile (P)",
        createObject: "Create object (O)",
        clearMeasurement: "Clear measurement",
      }
    }
  },
}
